import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import querystring from "query-string";
import { curry } from "ramda";
import { isValidArray } from "utils/validation";
export var PARAMSTYPES = {
  BooleanParam: function BooleanParam() {
    var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return string === "true";
  },
  NumberParam: function NumberParam() {
    var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var defaultValue = arguments.length > 1 ? arguments[1] : undefined;
    return string ? Number(string) : defaultValue || null;
  },
  ArrayParam: function ArrayParam() {
    var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var defaultValue = arguments.length > 1 ? arguments[1] : undefined;
    return string ? isValidArray(string) ? string : [].concat(string) : defaultValue || [];
  },
  DateParam: function DateParam() {
    var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var defaultValue = arguments.length > 1 ? arguments[1] : undefined;
    return string ? new Date(string) : defaultValue || null;
  },
  StringParam: function StringParam() {
    var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var defaultValue = arguments.length > 1 ? arguments[1] : undefined;
    return string ? string : defaultValue || null;
  }
};
export var parseSearchParams = function parseSearchParams(searchParams) {
  return Object.assign({}, querystring.parse("?".concat(searchParams.toString())));
};

//Turn array props into arrays, and booleans into booleans etc
export var transformSearch = curry(function (defaultParams, paramTypes, params) {
  return Object.keys(paramTypes).reduce(function (acc, key) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, paramTypes[key](acc[key], defaultParams[key])));
  }, params);
});

//create proper params object by reading searchParams and taking into account lowercase props
export var readValues = curry(function (defaultParams, parsedSearchParams) {
  return Object.keys(defaultParams).reduce(function (acc, key) {
    if (parsedSearchParams.hasOwnProperty(key)) acc[key] = parsedSearchParams[key];else if (parsedSearchParams.hasOwnProperty(key.toLowerCase())) acc[key] = parsedSearchParams[key.toLowerCase()];
    return acc;
  }, {});
});